import $x from '@/utils/$x';

/**
 * 查询上课教练列表
 * @param {*} params
 * @returns
 */
export async function getCoachPageList(params) {
  return $x.post('/coach/admin/pageList', params);
}

/**
 * 查询教练休假列表
 * @param {*} params
 * @returns
 */
export async function getCoachHoildayPageList(params) {
  return $x.post('/coach/holidays/pageList', params);
}

/**
 * 教练休假 新增
 * @param {*} params
 * @returns
 */
export async function addCoachHoilday(params) {
  return $x.post('/coach/holidays/add', params);
}

/**
 * 教练休假 删除
 * @param {*} params
 * @returns
 */
export async function deleteCoachHoilday(params) {
  return $x.post('/coach/holidays/delete', params);
}

/**
 * 教练休假 修改
 * @param {*} params
 * @returns
 */
export async function updateCoachHoilday(params) {
  return $x.post('/coach/holidays/update', params);
}

/**
 * 教练休假 查询
 * @param {*} params
 * @returns
 */
export async function getCoachHoildayDetail(params) {
  return $x.post('/coach/holidays/get', params);
}

/**
 * 教练休假 查询未离职的私教列表
 * @param {*} params
 * @returns
 */
export async function getPrivateCoachList(params) {
  return $x.post('/coach/holidays/privateCoachList', params);
}

//  教练是否参与排课开关
export async function coachOnline(params) {
  return $x.post('/coach/admin/scheduleSwitch', params);
}

//  教练是否参与作业调度开关
export async function homeworkSwitch(params) {
  return $x.post('/coach/admin/homeworkSwitch', params);
}

/**
 * 教练课表
 * @param {*} params
 * @returns
 */
export async function queryCoachScheduleByTime(params) {
  return $x.post('/coach/schedule/queryCoachScheduleByTime', params);
}

/**
 * 课表详情
 * @param {*} params
 * @returns
 */
export async function findCoachScheduleById(params) {
  return $x.post('/coach/schedule/findCoachScheduleById', params);
}

/**
 * 课表详情
 * @param {*} params
 * @returns
 */
export async function getCoachConfirmStatus(params) {
  return $x.post('/ptrainer/class/confirm/records', params);
}

/// @迁移
/// 获取下拉信息
export async function listUserOptions(params) {
  return $x.post('/common/listUserOptions', params);
}
//  教练入驻
export async function enterCoach(params) {
  return $x.post('/coach/admin/enter', params);
}

//  查询教练业务线信息
export async function getCoachLob(params) {
  return $x.post('/coach/admin/queryBeforeEdit', params);
}

//  查询教练业务线信息
export async function saveCoachLob(params) {
  return $x.post('/coach/admin/edit', params);
}

//  查询教练业务线信息
export async function getCoachLobV2(params) {
  return $x.post('/coach/admin/queryBeforeEdit/v2', params);
}

//  查询教练业务线信息
export async function saveCoachLobV2(params) {
  return $x.post('/coach/admin/edit/v2', params);
}

// 根据手机号查询教练的入驻情况
export async function getLobCoachDetail(params) {
  return $x.post('/coach/admin/queryBeforeEnter', params);
}

// 获取银行code
export async function getBankCode(params) {
  return $x.post('/common/listBankCodeList', params);
}

// 获取省份、城市
export async function getListArea(params) {
  return $x.post('/common/listArea', params);
}

// 切换上下架状态
export async function saleSwitch(params) {
  return $x.post('/coach/admin/saleSwitch', params);
}

// 排班查询
export async function coachStockSheet(params) {
  return $x.post('/coach/admin/coachStockSheet', params);
}

// 录入状态
export async function enterStock(params) {
  return $x.post('/coach/admin/enterStock', params);
}

// 教练授课资格
export async function teachingQualifications(params) {
  return $x.post('/coach/admin/teachingQualifications', params);
}

// 删除教练授课资格
export async function deleteTeachingQualifications(params) {
  return $x.post('/coach/admin/deleteTeachingQualifications', params);
}

// 阶段周期
export async function stagePeriod(params) {
  return $x.post('/coach/admin/stagePeriod', params);
}

// 添加资格
export async function addTeachingQualification(params) {
  return $x.post('/coach/admin/addTeachingQualification', params);
}

// 授课统计分页列表
export async function queryClassStatistics(params) {
  return $x.post('/coach/class/tj/list', params);
}

// 设置授课统计
export async function operateClassStatistics(params) {
  return $x.post('/coach/class/tj/set', params);
}

// 设置教练群码
export async function settingCoachGroupCode(params) {
  return $x.post('/coach/admin/settingCoachGroupCode', params);
}

// 教练群码查询
export async function getCoachGroupCode(params) {
  return $x.post('/coach/admin/getCoachGroupCode', params);
}

// 群名称列表
export async function listGroup(params) {
  return $x.post('/coach/admin/listGroup', params);
}
// 教练授课信息
export async function coachTeachingStatic(params) {
  return $x.post('/coach/class/tj/coachTeachingStatic', params);
}
// 教练授课信息详情
export async function consumerDetail(params) {
  return $x.post('/coach/class/tj/consumerDetail', params);
}
// 导出信息
export async function exportConsumerDetail(params) {
  return $x.post('/coach/class/tj/exportConsumerDetail', params);
}
// 开通大人物
export async function openBingBang(params) {
  return $x.post('/coach/admin/openBingBang', params);
}

// 开通企微账号
export async function openWx(params) {
  return $x.post('/coach/admin/openWx', params);
}

// 设置教练阶段
export async function modifyPhase(params) {
  return $x.post('/coach/admin/modifyPhase', params);
}

// 查询教练阶段
export async function getCoachPhase(params) {
  return $x.post('/coach/admin/getCoachPhase', params);
}
// 教练阶段枚举
export async function getCoachPhaseType(params) {
  return $x.post('/coach/admin/getCoachPhaseType', params);
}

// 分页查询操作记录
export async function pageCoachOpt(params) {
  return $x.post('/coach/admin/pageCoachOpt', params);
}
// 获取教练信息
export async function getCoachInfo(params) {
  return $x.post('/coach/admin/getCoachInfo', params);
}
// 获取个人空间的小程序二维码
export async function getPersonalSpaceInfoCode(params) {
  return $x.post('/coach/admin/getPersonalSpaceInfoCode', params);
}
// 同步教练到乐刻
export async function syncToLeke(params) {
  return $x.post('/coach/admin/syncToLeke', params);
}

// 擅长领域
export async function getExpertiseConfig(params) {
  return $x.post('/coach/admin/getExpertiseConfig/v2', params);
}
// 擅长领域
export async function querySignAli(params) {
  return $x.post('/coach/admin/sign', params);
}
// 修改支付宝账号
export async function editZfbId(params) {
  return $x.post('/coach/admin/editZfbId', params);
}
// 标记签约失效
export async function invalidateSign(params) {
  return $x.post('/coach/admin/invalidateSign', params);
}
// 修改支付宝账号
export async function listZfbChangeLog(params) {
  return $x.post('/coach/admin/listZfbChangeLog', params);
}
// 合同文件
export async function contractDocuments(params) {
  return $x.post('/coach/admin/contractDocuments', params);
}
// 教练进度
export async function getCoachProcess(params) {
  return $x.post('/athena/getCoachProcess', params);
}
// 注册教练
export async function registerCoach(params) {
  return $x.post('/coach/admin/registerCoach', params);
}
